import React from 'react';

import { MODALS } from 'global-constants';
import { withModal, FullScreenModal } from 'shared/components/Modals';

import ClaimCompany from './ClaimCompany';

class ClaimCompanyModal extends React.Component {
  render() {
    const { closeModal } = this.props;

    return (
      <FullScreenModal closeModal={closeModal}>
        <ClaimCompany {...this.props} />
      </FullScreenModal>
    );
  }
}

export default withModal(MODALS.CLAIM_COMPANY)(ClaimCompanyModal);
